/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlOnboardingActionItems } from './ControlOnboardingActionItems';
import {
    ControlOnboardingActionItemsFromJSON,
    ControlOnboardingActionItemsFromJSONTyped,
    ControlOnboardingActionItemsToJSON,
} from './ControlOnboardingActionItems';

/**
 * 
 * @export
 * @interface ControlUpdateOnboardingActionItemsRequest
 */
export interface ControlUpdateOnboardingActionItemsRequest {
    /**
     * 
     * @type {Array<ControlOnboardingActionItems>}
     * @memberof ControlUpdateOnboardingActionItemsRequest
     */
    add?: Array<ControlOnboardingActionItems>;
    /**
     * 
     * @type {Array<ControlOnboardingActionItems>}
     * @memberof ControlUpdateOnboardingActionItemsRequest
     */
    remove?: Array<ControlOnboardingActionItems>;
}

/**
 * Check if a given object implements the ControlUpdateOnboardingActionItemsRequest interface.
 */
export function instanceOfControlUpdateOnboardingActionItemsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlUpdateOnboardingActionItemsRequestFromJSON(json: any): ControlUpdateOnboardingActionItemsRequest {
    return ControlUpdateOnboardingActionItemsRequestFromJSONTyped(json, false);
}

export function ControlUpdateOnboardingActionItemsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUpdateOnboardingActionItemsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'add': !exists(json, 'add') ? undefined : ((json['add'] as Array<any>).map(ControlOnboardingActionItemsFromJSON)),
        'remove': !exists(json, 'remove') ? undefined : ((json['remove'] as Array<any>).map(ControlOnboardingActionItemsFromJSON)),
    };
}

export function ControlUpdateOnboardingActionItemsRequestToJSON(value?: ControlUpdateOnboardingActionItemsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'add': value.add === undefined ? undefined : ((value.add as Array<any>).map(ControlOnboardingActionItemsToJSON)),
        'remove': value.remove === undefined ? undefined : ((value.remove as Array<any>).map(ControlOnboardingActionItemsToJSON)),
    };
}

